import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { checkboxDriverFactory as coreCheckboxDriverFactory } from '../internal/WixUiCoreComponents/components/CoreCheckbox/CoreCheckbox.uni.driver';
import { uniDriverImplementation } from '../../test/unidriver-config';

export interface IconToggleDriver
  extends BaseUniDriver,
    ReturnType<typeof coreCheckboxDriverFactory> {
  click(): Promise<void>;
  label: UniDriver & {
    placement: () => Promise<string>;
  };
  icon: UniDriver;
}

// TODO: JB: extract and reuse in components
const dataHooks = {
  label: '[data-label]',
  icon: '[data-icon]',
};

export const iconToggleDriverFactory = (
  base: UniDriver,
  body: UniDriver,
): IconToggleDriver => {
  return {
    ...baseUniDriverFactory(base),
    ...coreCheckboxDriverFactory(
      uniDriverImplementation.current(
        async () => (await base.getNative()).children[0],
      ),
      body,
    ),
    click: async () => (await (await base.get(`label`)).getNative()).click(), // TODO: JB: must click on native in jsdom to properly simulate click on label instead of relying on driver.click(): https://github.com/testing-library/user-event/issues/1230
    label: {
      ...base.$(dataHooks.label),
      placement: () => base.attr('data-label-placement'),
    },
    icon: base.$(dataHooks.icon),
  };
};
